function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Folder",
  transform: "translate(-55.961 -143.299)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Folder--Background",
  d: "M111.578,192.745H69.743A3.452,3.452,0,0,1,66.3,189.3V157.04a3.449,3.449,0,0,1,3.443-3.44H83.829l5.712,5.461h22.038a3.452,3.452,0,0,1,3.443,3.44V189.31A3.451,3.451,0,0,1,111.578,192.745Z",
  transform: "translate(-9.69 -9.654)",
  fill: "#25a4b4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Folder--Border",
  d: "M101.956,182.624H60.037a2.963,2.963,0,0,1-2.3-1.064,3.009,3.009,0,0,1-.658-1.969V148.564a5.493,5.493,0,0,1,.307-2.55,2.969,2.969,0,0,1,2.654-1.612H74.115c-.132-.055-.258-.11-.389-.159q2.468,2.361,4.93,4.716c.258.247.5.5.768.735a.758.758,0,0,0,.565.192h20.927c.439,0,.9-.027,1.338.011a2.941,2.941,0,0,1,2.6,2.945v26.844a2.951,2.951,0,0,1-.609,1.81,2.878,2.878,0,0,1-2.287,1.13.549.549,0,0,0,0,1.1,4.053,4.053,0,0,0,3.965-3.477,9.035,9.035,0,0,0,.038-1.157V152.808a4.066,4.066,0,0,0-2.687-3.795,5.3,5.3,0,0,0-1.854-.225H79.84c.132.055.258.11.389.159q-1.982-1.9-3.97-3.795c-.57-.548-1.13-1.108-1.716-1.64-.318-.285-.784-.2-1.185-.2H60.876a9.7,9.7,0,0,0-1.645.071,4.055,4.055,0,0,0-3.252,3.74c-.038.724-.005,1.459-.005,2.188v30.414a4.056,4.056,0,0,0,3.038,3.883,9.876,9.876,0,0,0,2.347.121h40.586A.551.551,0,0,0,101.956,182.624Z",
  transform: "translate(0 0)",
  fill: "#25a4b4"
}));

var SvgFolder = function SvgFolder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40.439,
    viewBox: "0 0 50 40.439",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFolder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/folder.092855d3.svg";
export { ForwardRef as ReactComponent };